import React from 'react'
import PropTypes from 'prop-types'
import { Card, Row, Col, Statistic, Spin } from 'antd'
import { CheckCircleOutlined, ClockCircleOutlined, WarningOutlined, FileTextOutlined } from '@ant-design/icons'
import './Component.css'

export default class _StatsBar_ extends React.PureComponent {

  static propTypes = {
    statistics: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
  }

  render () {

    var { statistics, loading } = this.props

    if (loading) {
      return (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <Spin />
        </div>
      )
    }

    return (
      <div className="tbt-stats-bar">
        <Row gutter={16}>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <Card>
              <Statistic
                title="Active Documents"
                value={statistics.active_documents || 0}
                prefix={<FileTextOutlined />}
              />
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <Card>
              <Statistic
                title="Completion Rate"
                value={statistics.completion_rate || 0}
                suffix="%"
                prefix={<CheckCircleOutlined />}
                valueStyle={{ color: (statistics.completion_rate || 0) >= 80 ? '#3f8600' : '#cf1322' }}
              />
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <Card>
              <Statistic
                title="Pending Signatures"
                value={statistics.total_pending || 0}
                prefix={<ClockCircleOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <Card>
              <Statistic
                title="Overdue"
                value={statistics.overdue_count || 0}
                prefix={<WarningOutlined />}
                valueStyle={{ color: (statistics.overdue_count || 0) > 0 ? '#cf1322' : '#3f8600' }}
              />
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}
